module.exports = {"370116001":"凤城街道","370116002":"张家洼街道","370116003":"高庄街道","370116004":"鹏泉街道","370116005":"口镇街道","370116006":"羊里街道","370116007":"方下街道","370116008":"雪野街道","370116103":"牛泉镇","370116104":"苗山镇","370116106":"大王庄镇","370116107":"寨里镇","370116108":"杨庄镇","370116109":"茶业口镇","370116110":"和庄镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370116.json
// module id = 1474
// module chunks = 0